import { SmartfireComponent } from '@smartfire/gutenberg-react';
import './style.scss';
import * as React from 'react';
import { animateScroll as scroll } from 'react-scroll';

export default class FroidBlocklistShortcutBlock extends SmartfireComponent {
    scrollToSection = (section) => {
        const element = document.getElementById(section);
        const rect = element.getBoundingClientRect();
        scroll.scrollTo(rect.top - 200 + window.scrollY);
    };

    render() {
        return (
            <div className="blocklist-shortcut">
                <div className="content-container">
                    <h2 className="content-title">
                        Notre gamme de produits frigorifiques
                    </h2>
                    <p className="content-description">
                        Nous vous proposons le meilleur service de stockage frigorifique
                        mobile pour répondre à tous vos besoins.
                        <br />
                        L’offre Froid Solutions s’articule autour de 3 solutions
                        frigorifiques en containers, neufs ou d’occasion.
                    </p>
                    <div className="columns">
                        {this.props.sections.map((section, i) => (
                            <div
                                key={i}
                                className="column"
                                onClick={() => this.scrollToSection(section.categoryName)}
                            >
                                <span>{section.categoryName}</span>
                                <div className="button" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}
